import React, { useContext } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import RoyaltiesAnnualStatementsRow from '@Scenes/RightsholderScene/RightsholderRoyaltiesAnnualStatements/RoyaltiesAnnualStatementsTable/RoyaltiesAnnualStatementsRow'

interface RoyaltiesAnnualStatementsTableProps {
    sendTSVRequest: (payeeId: number) => void
}

const RoyaltiesAnnualStatementsTable = (props: RoyaltiesAnnualStatementsTableProps) => {
    const { statementsStore } = useContext(StoresContext)
    const { sendTSVRequest } = props
    const royalties = statementsStore.royalties

    return (
        <div className="royalties-table annual-statements-table">
            <table>
                <tbody>
                    <tr>
                        <th>Publisher Number</th>
                        <th>Payee Name</th>
                        <th>Opening Balance</th>
                        <th>Royalties in Period</th>
                        <th>Payable Amount</th>
                        <th>Amount Paid</th>
                        <th>Closing Balance</th>
                        <th>Payee Activity</th>
                        <th>Statements</th>
                    </tr>
                    {royalties &&
                        royalties?.length > 0 &&
                        royalties.map((row, idx) => (
                            <RoyaltiesAnnualStatementsRow
                                sendTSVRequest={sendTSVRequest}
                                payeeRoyalties={row}
                                key={idx}
                            />
                        ))}
                </tbody>
            </table>
            {royalties?.length === 0 && (
                <div className="no-statements-message">
                    No <strong>Annual Statement</strong> available
                </div>
            )}
        </div>
    )
}

export default observer(RoyaltiesAnnualStatementsTable)
